import React from "react";
import less from "./seatUpgrade.module.scss";

const seatUpgrade = props => {
  return props.isSeatUpgraded ? (
    <div className={less.container}>
      <div>
        <h2>Journey upgraded successfully</h2>
        <span>
         Your journey has been successfully upgraded
        </span>
      </div>
      <img
        src="https://d1flzashw70bti.cloudfront.net/original/images/seatUpgrade/seat.svg"
        alt="seat upgrade"
      />
    </div>
  ) : (
    <div className={less.container}>
      <div>
        <h2>Upgrade your bus journey</h2>
        <span>Tap to view available upgrade options</span>
        <button onClick={props.redirectToSeatUpdrade}>Upgrade Now</button>
      </div>
      <img
        src="https://d1flzashw70bti.cloudfront.net/original/images/seatUpgrade/seat.svg"
        alt="seat upgrade"
      />
    </div>
  );
};

export default seatUpgrade;
